// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"312":"368eabc0","629":"342a4cb4"}[chunkId] + ".chunk.js");